import { AttributeDTO } from '@/entities/srm/ci/@x/enrichment';
import { z } from 'zod/v4';

// AttributeStatisticDTO extends PickType(Attribute, ['name']) + extra fields
export const AttributeStatisticDTO = AttributeDTO.pick({
  name: true,
}).extend({
  status: z.string(),
  log_id: z.string(),
});
export type AttributeStatistic = z.infer<typeof AttributeStatisticDTO>;

// LinkStatisticDTO standalone
export const LinkStatisticDTO = z.object({
  name: z.string(),
  dst_ci_type_name: z.string(),
  status: z.string(),
  log_id: z.string(),
});
export type LinkStatistic = z.infer<typeof LinkStatisticDTO>;

// EnrichmentCiStatisticDTO
export const EnrichmentCiStatisticDTO = z.object({
  ci_id: z.string(),
  ci_type_name: z.string(),
  attributes: z.array(AttributeStatisticDTO),
  links: z.array(LinkStatisticDTO),
  progress: z
    .object({
      status: z.string(),
      log_id: z.string(),
    })
    .nullable()
    .optional(),
});
export type EnrichmentCiStatistic = z.infer<typeof EnrichmentCiStatisticDTO>;

// EnrichmentCiTypeStatisticDTO
export const EnrichmentCiTypeStatisticDTO = z.object({
  ci_statistics: z.array(EnrichmentCiStatisticDTO),
  nodes: z.record(z.string(), z.string()),
});
export type EnrichmentCiTypeStatistic = z.infer<
  typeof EnrichmentCiTypeStatisticDTO
>;

// EnrichmentCiTypeStatisticLogsDTO
export const EnrichmentCiTypeStatisticLogsDTO = z.object({
  records: z.array(
    z.object({
      record: z.string(),
      timestamp: z.string(),
    }),
  ),
});
export type EnrichmentCiTypeStatisticLogs = z.infer<
  typeof EnrichmentCiTypeStatisticLogsDTO
>;